export * from './audit.service';
import { AuditService } from './audit.service';
export * from './document.service';
import { DocumentService } from './document.service';
export * from './health.service';
import { HealthService } from './health.service';
export * from './job.service';
import { JobService } from './job.service';
export * from './operation.service';
import { OperationService } from './operation.service';
export * from './page.service';
import { PageService } from './page.service';
export * from './prospect.service';
import { ProspectService } from './prospect.service';
export * from './schema.service';
import { SchemaService } from './schema.service';
export * from './template.service';
import { TemplateService } from './template.service';
export const APIS = [AuditService, DocumentService, HealthService, JobService, OperationService, PageService, ProspectService, SchemaService, TemplateService];
